export class Billing {
  BillingId: number;
  ProfileId: number;
  AnchorMonth: number;
  AnchorDay: number;
  StartingYear: number;
  RevenueItem: string;
  ItemNum: number;
  Quantity: number;
  UnitPrice: number;
  BasePrice: number;
  FlatFee: number;
  BillingCycle: string;
  AmountPerCycle: number;
  YearlyAmount: number;
  Notes: string;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  SoldBy: number;
  Taxable: boolean;
  Descr: string;
  Options: string;
  Attention: string;
  InvoiceSeparately: boolean;
  BillManually: boolean;
  ServicePeriod_StartPeriodDay: number;
  ServicePeriod_EndPeriodDay: number;
  ApplyDateDay: number;
  Inactive: boolean;
  DateInactive: Date;
  BillingExpires: boolean;
  BillingExpireDate: Date;
  Contract: string;
  FairShare: number;
  PledgeID: number;
  BTName: string;
  BTAddress1: string;
  BTAddress2: string;
  BTCity: string;
  BTCountry: string;
  BTState: string;
  BTZip: string;
  BTZipExt: string;
  STName: string;
  STAddress1: string;
  STAddress2: string;
  STCity: string;
  STState: string;
  STZip: string;
  STZipExt: string;
  CommunicateWithProfileID: number;
  IsARB: boolean;
  ARBID: number;
  PreTaxAmount: number;
  TaxAmount: number;
  AllowPortalArbSubscription: boolean;
}
